module.exports = __webpack_public_path__ + "static/SESF_logo_squared-fb31ab27e8cb474e944f310c39a9d819.png";